import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loader"></div>
      <div className="loader2"></div>
    </div>
  );
};

export default Loading;